<template>
  <div class="topbar-item">
    <div
      class="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"
      id="kt_quick_user_toggle"
    >
      <span class="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1">Привет,</span>
      <span
        class="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3"
      >{{user.name}}</span>
      <span class="symbol symbol-35 symbol-light-success">
        <span class="symbol-label font-size-h5 font-weight-bold">{{avatar}}</span>
      </span>
    </div>
  </div>
</template>

<script>
import { LOGOUT } from "@/core/services/store/auth.module";

export default {
  name: "KTQuickUser",
  data() {
    return {
      list: []
    };
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    avatar() {
      let fio = this.user.name.split(" ");

      if (fio.length == 1) {
        return fio[0].charAt(0).toUpperCase();
      } else {
        return [fio[0].charAt(0), fio[1].charAt(0)].join("").toUpperCase();
      }
    }
  },
  methods: {
    onLogout() {
      this.$store
        .dispatch(LOGOUT)
        .then(() => this.$router.push({ name: "login" }));
    }
  }
};
</script>
